import Vue from 'vue';
import Storage from '@/storage/Storage';
import { LAYOUTS } from '../constants';
import _ from 'underscore';
import { EventBus } from '@/eventBus';

export default {
	state: () => ({
		siteLoading: false,
		theme: 'dark',
		menuOpen: false,
		accountMenuOpen: false,
		layout: LAYOUTS.SALES,
		title: 'Gravity Fox',
		navAccountsVisible: true,
		toasts: {},
		// Queued Toasts appear on the next page navigation
		queuedToasts: [],
		whiteLabelAccount: {},
	}),

	getters: {

		toasts(state) {
			return Object.values(state.toasts);
		},

		hasToasts(state) {
			return Object.values(state.toasts).length > 0;
		},

		siteTitle(state) {
			return state.title;
		},

		whiteLabelAccount(state) {
			return state.whiteLabelAccount;
		},

	},

	mutations: {

		setLayout(state, layout) {
			state.layout = layout;
		},

		setSiteLoading(state, isLoading) {
			state.siteLoading = isLoading;
		},

		setTitle(state, title) {
			state.title = title;
		},

		setWhiteLabelAccount(state, account) {
			state.whiteLabelAccount = account;
		},

		setNavAccountsVisible(state, navAccountsVisible) {
			state.navAccountsVisible = navAccountsVisible;
		},

		setTheme(state, { theme, store = true }) {
			const themesAvailable = [ 'dark', 'light' ];
			if (themesAvailable.indexOf(theme) === -1) {
				return;
			}

			if (store) {
				Storage.set('theme', theme, { preferCookies: true });
			}

			state.theme = theme;
		},

		setMenuOpen(state) {
			state.menuOpen = true;
		},

		setMenuClosed(state) {
			state.menuOpen = false;
		},

		setAccountMenuOpen(state) {
			state.accountMenuOpen = true;
		},

		setAccountMenuClosed(state) {
			state.accountMenuOpen = false;
		},

		addToast(state, { id, toast }) {
			toast.id = id;
			Vue.set(state.toasts, id, toast);
		},

		removeToast(state, id) {
			clearInterval(state.toasts[ id ].intRef);
			// this.$delete(state.toasts, id);
			Vue.delete(state.toasts, id);
		},

		updateToastDuration(state, { id, duration }) {
			Vue.set(state.toasts[ id ], 'duration', state.toasts[ id ].duration - duration);
		},

		setToastDuration(state, { id, duration}) {
			Vue.set(state.toasts[ id ], 'duration', duration);
		},

		addQueuedToast(state, toast) {
			state.queuedToasts.push(toast);
		},

		clearQueuedToasts(state) {
			state.queuedToasts = [];
		},
	},

	actions: {

		async loadWhiteLabelAccount({ commit }, subdomain) {
			try {
				const { data } = await this.$api.get(`/account-info/${subdomain}`);

				if (data) {
					commit('setWhiteLabelAccount', data);
					return data;
				}
			} catch(e) {
				console.log('e', e);
			}

			return null;
		},

		setLayout({ commit }, layout = LAYOUTS.SALES) {
			commit('setLayout', layout);
		},

		setSiteLoading({ commit }, isLoading = true) {
			commit('setSiteLoading', isLoading);
		},

		setTitle({ commit }, title) {
			commit('setTitle', title);
		},

		setNavAccountsVisible({ commit }, navAccountsVisible) {
			commit('setNavAccountsVisible', navAccountsVisible);
		},

		updateTheme({ commit, getters, dispatch }, { theme, store = true }) {
			if (getters.isLoggedIn) {
				let user = getters.currentUser;
				dispatch('setUser', {
					...user || {},
					theme,
				});
			}

			commit('setTheme', { theme, store });
		},

		openMenu({ commit }) {
			commit('setMenuOpen');
		},

		closeMenu({ commit }) {
			commit('setMenuClosed');
		},

		openAccountMenu({ commit }) {
			commit('setAccountMenuOpen');
		},

		closeAccountMenu({ commit }) {
			commit('setAccountMenuClosed');
		},

		queueToast({ commit }, toast = {}) {
			commit('addQueuedToast', {
				toast: Object.assign({
					message: '',
					type: 'good-bg',
					icon: 'fa-times',
				}, toast),
			});
		},

		// this.$store.dispatch('addToast', {
		// 	message: 'test',
		// });
		// this.$store.dispatch('addToast', 'test');

		addToast({ commit, dispatch, getters }, toast = {}) {
			const duration = 4500;
			if (typeof toast === 'string') return dispatch('addToast', { message: toast });

			// Ensure no duplicate
			const duplicates = getters.toasts.filter(existingToast => {
				if (toast && toast.message == existingToast.message) {
					commit('setToastDuration', { id: existingToast.id, duration });
					return true;
				}

				return false;
			});

			if (duplicates.length > 0) return;

			const id = _.uniqueId('toast-');
			commit('addToast', {
				id,
				toast: Object.assign({
					message: '',
					type: 'good-bg',
					icon: 'fa-angle-up',
					onClick: () => {
						commit('removeToast', id);
					},
					intRef: setInterval(() => {
						dispatch('updateToastDuration', { id, duration: 250 });
					}, 250),
					duration,
				}, toast),
			});
		},

		errorToast({ dispatch }, message) {
			dispatch('addToast', { message, type: 'bad-bg' });
		},

		removeToast({ commit }, toast) {
			if (typeof toast === 'object' && toast.hasOwnProperty('id')) {
				commit('removeToast', toast.id);
			} else {
				commit('removeToast', toast);
			}
		},

		pauseToast({ state }, id) {
			if (typeof state.toasts[ id ] === 'undefined') return;
			clearInterval(state.toasts[ id ].intRef);
		},

		resumeToast({ state, dispatch }, id) {
			if (typeof state.toasts[ id ] === 'undefined') return;

			clearInterval(state.toasts[ id ].intRef);
			state.toasts[ id ].intRef = setInterval(() => {
				dispatch('updateToastDuration', { id, duration: 100 });
			}, 100);
		},

		updateToastDuration({ commit, state }, { id, duration }) {
			if (typeof state.toasts[ id ] === 'undefined') return;

			if (state.toasts[ id ].duration < duration) {
				// Close Toast
				commit('removeToast', id);
			} else {
				commit('updateToastDuration', { id, duration });
			}
		},

		closeDrawers() {
			EventBus.$emit('close-all-drawers');
		},
	},
};
